// extracted by mini-css-extract-plugin
module.exports = {"cookieBar":"cookieBar_cookieBar__qr0Ha","cookieBarText":"cookieBar_cookieBarText__yxaBP","cookieBarContainer":"cookieBar_cookieBarContainer__jKjKo","link":"cookieBar_link__urOjI"};